/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var browser = require('./browser');

var isInstalled = browser.isDingding() && (typeof dd === 'undefined' ? 'undefined' : (0, _typeof3["default"])(dd)) == 'object';
var JSAPI_LIST = ['device.notification', 'biz.contact.choose', 'biz.contact.complexChoose', 'biz.user.get', 'biz.util.openLink', 'biz.navigation', 'biz.alipay.pay'];
var notInstallResponse = { status: 'n', flag: 101, info: '未引入dingding sdk' };
var ding = window.dd;
// var dingLogo = '//mudu.tv/assets/img/index/dingding.png';
var GET_USER_INFO_URL = 'http://mudu.tv/dingding.php?a=ajaxGetUserInfo';

exports.init = function (obj, cb) {
    if (!isInstalled) {
        return notInstallResponse;
    }
    ding.config({
        agentId: obj.agentId,
        corpId: obj.corpId,
        timeStamp: obj.timeStamp,
        nonceStr: obj.nonceStr,
        signature: obj.signature,
        jsApiList: JSAPI_LIST
    });
    ding.ready(function () {
        typeof cb === 'function' && cb();
    });
    ding.error(function (err) {
        // eslint-disable-next-line
        console.warn(err);
    });
};

exports.login = function (corpId, cb) {
    getAuthCode(corpId, function (code) {
        var data = { code: code, corpId: corpId };
        Fetcher.PostForm(GET_USER_INFO_URL, data, function (res) {
            res = JSON.parse(res);
            if (res.status == 'y') {
                var detail = res.data.detail || {};
                // setUserInfo({id: detail.userid, user: detail.name, avatar: detail.avatar});
                typeof cb === 'function' && cb({
                    id: detail.userid,
                    user: detail.name,
                    avatar: detail.avatar
                });
            } else {
                // utils.SetCookie('openId', '');
            }
        });
    });
};

// function setUserInfo ({id, user, avatar}) {
//     id && utils.SetCookie('visitorId', 'dingding' + id);
//     id && utils.SetCookie('openId', id);
//     user && utils.SetCookie('user', user);
//     avatar && utils.SetCookie('avatar', avatar);
// }

function getAuthCode(corpId, cb) {
    ding.ready(function () {
        ding.runtime.permission.requestAuthCode({
            corpId: corpId,
            onSuccess: function onSuccess(res) {
                cb(res.code);
            },
            onFail: function onFail(err) {
                // eslint-disable-next-line
                console.warn(err);
            }
        });
    });
}



/*****************
 ** WEBPACK FOOTER
 ** ./application/helper/dingding.js
 ** module id = 164
 ** module chunks = 1
 **/